import { formatCell } from '../../../utils/numbers';

const LOCALE = 'en-US';

const compactNumber = value =>
    new Intl.NumberFormat(LOCALE, { notation: 'compact', maximumFractionDigits: 1 }).format(value);

const groupedNumber = value => new Intl.NumberFormat(LOCALE).format(value);

export const formatKpiValue = (value, format, unit, { compact = true } = {}) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return String(value);
    }

    switch (format) {
        case 'currency':
            return formatCell((compact ? compactNumber : groupedNumber)(value), {
                type: 'currency',
                symbol: unit || '$',
            });
        case 'percent':
            return `${Number((value * 100).toFixed(1))}%`;
        case 'number': {
            const formatted = formatCell(groupedNumber(value), { type: 'number', precision: 1 });
            return unit ? `${formatted} ${unit}` : formatted;
        }
        default:
            return String(value);
    }
};

export const formatKpiDelta = delta => {
    if (typeof delta !== 'number' || Number.isNaN(delta)) {
        return null;
    }

    const pct = Number((delta * 100).toFixed(1));
    const direction = pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat';
    const sign = pct > 0 ? '+' : '';
    return { text: `${sign}${pct}%`, direction };
};
